import { Action, createReducer, on } from '@ngrx/store';
import { RelationshipDesignationTypes } from '@shared/models/relationship-designation-types';
import * as AdaptedStateActions from '@store/actions/adapted-state/adapted-state.actions';

import * as beneficiariesActions from '../../actions/beneficiaries/beneficiaries.actions';

export interface BeneficiariesState {
  relationshipDesignation: RelationshipDesignationTypes;
  onlyChild: boolean;
  otherBenes: Person[];
}

export interface Person {
  name: string;
  dateGroup: {
    dob: string;
    dod?: string;
  };
  hasChildren?: boolean;
  children?: Person[];
}

export const initialState: BeneficiariesState = {
  relationshipDesignation: RelationshipDesignationTypes.UNKNOWN,
  onlyChild: false,
  otherBenes: [],
};

const beneficiariesReducer = createReducer(
  initialState,
  on(beneficiariesActions.UpdateRelationshipDesignation, (state, { payload }) => {
    return {
      ...state,
      relationshipDesignation: payload,
    };
  }),
  on(beneficiariesActions.UpdateOnlyChild, (state, { payload }) => {
    return {
      ...state,
      onlyChild: payload,
    };
  }),
  on(beneficiariesActions.UpdateOtherBene, (state, { payload }) => {
    return {
      ...state,
      otherBenes: payload,
    };
  }),
  on(AdaptedStateActions.ClearCurrentTransactionState, () => {
    return initialState;
  }),
  on(AdaptedStateActions.SetTransactionAsCurrent, (state, { transaction }) => {
    return {
      ...state,
      ...transaction.beneficiaries,
    };
  }),
);

export function reducer(state: BeneficiariesState | undefined, action: Action) {
  return beneficiariesReducer(state, action);
}

export const getRelationshipDesignation = (state: BeneficiariesState) =>
  state.relationshipDesignation;
export const getIsDescendant = (state: BeneficiariesState) =>
  RelationshipDesignationTypes.DESCENDANT === getRelationshipDesignation(state);
export const getIsGrandchild = (state: BeneficiariesState) =>
  RelationshipDesignationTypes.GRANDCHILD === getRelationshipDesignation(state);
